import React from 'react';
import { Breadcrumb, Card } from 'antd';
import { Link } from 'react-router-dom';

import ProfileHeader from './profile-header/index.js';
import ProfileBody from './profile-body/index.js';

// import ProductTable from './product-table';
// import SalesChart from './sales-chart';

import  './index.css';

class SupplierProfile extends React.Component {

    render() {

        const { supplierId } = this.props;
        const { supplierName } = this.state;
        return(
            <div className="component-container" >

                <Card 
                    title={<div>
                        <Breadcrumb className="breadcrumbs" separator="|">
                            <Breadcrumb.Item><Link to="/supplier">Suppliers List</Link></Breadcrumb.Item>
                            <Breadcrumb.Item className="active-breadcrumb">{supplierName}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>}>

                    <ProfileHeader onUpdate={this.onUpdate} onRefreshProducts={this.onRefreshProducts} supplierId={supplierId}/>
                    

                </Card>

                <div style={{margin:24}}>
                    <ProfileBody key={this.state.refreshKey} supplierId={this.state.supplierId}/>
                </div>

                {/* <Card>
                    
                </Card> */}

            </div>
        )
    }

    constructor(props) {
        super(props);
        this.state = {
            supplierId: props.supplierId,
            supplierName: false,
            refreshKey: 0
            // tempId: '5a203670735a7d0cbca50f29'
        }
    }

    onUpdate = (supplierName) => {
        this.setState({
            supplierName
        })
    }

    onRefreshProducts = () => {
        this.setState(prev => ({ refreshKey: prev.refreshKey + 1 }))
    }
}

export default SupplierProfile;


// WEBPACK FOOTER //
// ./src/components/supplier-profile/index.js